import {
    EquipmentTimersDurationByProductListChart,
    IotsUptimeByTypeListChart,
    IotsUptimeLineChart,
    IotsUptimeWeekdayHeatmapChart,
    IotsVolumeByStatusBarChart,
    IotsVolumeByTypeListChart,
    LendingEquipmentUsesVolumeByProductListChart,
    LendingOutboundPackageVolumeByProductMonthlyListChart,
    LendingOutboundPackageVolumeHourDayHeatmapChart as LendingOutboundPackageVolumeHourDayHeatmapChartRenderer,
    LendingOutboundPackageVolumeWeekdayHeatmapChart,
    LendingReturnPackageVolumeHourDayHeatmapChart as LendingReturnPackageVolumeHourDayHeatmapChartRenderer,
    LendingReturnPackageVolumeWeekdayHeatmapChart,
    NivalizInboundTransactionTimerActivityHourDayHeatmapChart,
    NivalizInboundTransactionTimerActivityWeekdayHeatmapChart,
    NivalizOutboundTransactionTimerActivityHourDayHeatmapChart,
    NivalizOutboundTransactionTimerActivityWeekdayHeatmapChart,
    NivalizTransactionVolumeBySlotDimensionDonutChart,
    PudoTransactionTimerActivityHourDayHeatmapChart,
    PudoTransactionTimerActivityWeekdayHeatmapChart,
    PudoTransactionTimersDurationByUserDropOffListChart,
    PudoTransactionTimersDurationByUserPickUpListChart,
    PudoTransactionVolumeByReceiverListChart,
    PudoTransactionVolumeBySenderListChart,
    PudoTransactionVolumeBySlotDimensionDonutChart,
    PudoTransactionVolumeBySpotDonutChart,
    VendingPackageTimersDurationAuditPendingByProductListChart,
    VendingPackageVolumeByUserListChart,
    VendingPackageVolumeHourDayHeatmapChart,
    VendingRecycleSpotFillRateLineChart,
    VendingReplenishmentTransactionVolumeHourDayHeatmapChart
} from '@frontend/chart/components';
import { ChartBinSize, ChartInfoKind } from '@frontend/chart/types';
import { Application, Feature } from '@frontend/functionality/types';
import { ReportType } from '@frontend/report/types';
import { TransactionTimerName } from '@frontend/transaction/types';
import { FormattedMessage } from 'react-intl';

import { HardwareIotsVolumeByTypeListChart } from '../../../statistics/hardware/hardware-iots-volume-by-type-list-chart/hardware-iots-volume-by-type-list-chart.component';
import { Last6MonthsHardwareIotsUptimeWeekdayHeatmapChart } from '../../../statistics/hardware/last-6-months-hardware-iots-uptime-weekday-heatmap-chart/last-6-months-hardware-iots-uptime-weekday-heatmap-chart.component';
import { Last30DaysHardwareIotsUptimeByTypeListChart } from '../../../statistics/hardware/last-30-days-hardware-iots-uptime-by-type-list-chart/last-30-days-hardware-iots-uptime-by-type-list-chart.component';
import { Last30DaysHardwareIotsUptimeLineChart } from '../../../statistics/hardware/last-30-days-hardware-iots-uptime-line-chart/last-30-days-hardware-iots-uptime-line-chart.component';
import { Last30DaysHardwareIotsVolumeByStatusBarChart } from '../../../statistics/hardware/last-30-days-hardware-iots-volume-by-status-bar-chart/last-30-days-hardware-iots-volume-by-status-bar-chart.component';
import { Last6MonthsLendingOutboundPackageVolumeWeekdayHeatmapChart } from '../../../statistics/lending/last-6-months-lending-outbound-package-volume-weekday-heatmap-chart/last-6-months-lending-outbound-package-volume-weekday-heatmap-chart.component';
import { Last6MonthsLendingReturnPackageVolumeWeekdayHeatmapChart } from '../../../statistics/lending/last-6-months-lending-return-package-volume-weekday-heatmap-chart/last-6-months-lending-return-package-volume-weekday-heatmap-chart.component';
import { Last30DaysLendingAverageUseDurationByProductListCard } from '../../../statistics/lending/last-30-days-lending-average-use-duration-by-product-list-card/last-30-days-lending-average-use-duration-by-product-list-card.component';
import { Last60DaysLendingOutboundPackageVolumeByProductMonthlyListChart } from '../../../statistics/lending/last-60-days-lending-outbound-package-volume-by-product-monthly-list-chart/last-60-days-lending-outbound-package-volume-by-product-monthly-list-chart.component';
import { LendingEquipmentUsageHoursList } from '../lending/lending-equipment-usage-hours-list.component';
import { LendingEquipmentUsesVolumeByProductList } from '../lending/lending-equipment-uses-volume-by-product-list.component';
import { LendingOutboundPackageVolumeHourDayHeatmapChart } from '../lending/lending-outbound-package-volume-hour-day-heatmap-chart.component';
import { LendingReturnPackageVolumeHourDayHeatmapChart } from '../lending/lending-return-package-volume-hour-day-heatmap-chart.component';
import {
    Last2WeeksNivalizCoffinsTransactionTimerActivityHourDayHeatmapChart,
    Last2WeeksNivalizUrnsTransactionTimerActivityHourDayHeatmapChart
} from '../nivaliz/last-2-weeks-nivaliz-transaction-timer-activity-hour-day-heatmap-chart.component';
import {
    Last6MonthsNivalizCoffinsTransactionTimerActivityWeekdayHeatmapChart,
    Last6MonthsNivalizUrnsTransactionTimerActivityWeekdayHeatmapChart
} from '../nivaliz/last-6-months-nivaliz-transaction-timer-activity-weekday-heatmap-chart.component';
import { NivalizCompartmentUsageBySizeDonutChart } from '../nivaliz/nivaliz-compartment-usage-by-size-donut-chart.component';
import { NivalizDailyTurnoverRateLineChart } from '../nivaliz/nivaliz-daily-turnover-rate-line-chart.component';
import { Last2WeeksPudoTransactionTimerActivityHourDayHeatmapChart } from '../pudo/last-2-weeks-pudo-transaction-timer-activity-hour-day-heatmap-chart.component';
import { Last6MonthsPudoTransactionTimerActivityWeekdayHeatmapChart } from '../pudo/last-6-months-pudo-transaction-timer-activity-weekday-heatmap-chart.component';
import { PudoCompartmentUsageBySizeDonutChart } from '../pudo/pudo-compartment-usage-by-size-donut-chart.component';
import { PudoDailyTurnoverRateLineChart } from '../pudo/pudo-daily-turnover-rate-line-chart.component';
import { PudoSlowestDropOffUsersList, PudoSlowestPickUpUsersList } from '../pudo/pudo-transaction-timer-duration-by-user-list.component';
import { PudoTransactionsBySpotDonutChart } from '../pudo/pudo-transaction-volume-by-spot-donut-chart.component';
import { PudoTransactionVolumeByReceiverList, PudoTransactionVolumeBySenderList } from '../pudo/pudo-transaction-volume-by-user-list.component';
import { StalePudoTransactionsList } from '../pudo/stale-pudo-transactions-list.component';
import { Last2WeeksVendingPackageVolumeHourDayHeatmapChart } from '../vending/last-2-weeks-vending-package-volume-hour-day-heatmap-chart.component';
import { Last2WeeksVendingReplenishmentActivityHourDayHeatmapChart } from '../vending/last-2-weeks-vending-replenishment-activity-hour-day-heatmap-chart.component';
import { Last30DaysVendingRecycleSpotFillRateLineChart } from '../vending/last-30-days-vending-recycle-spot-fill-rate-line-chart.component';
import { VendingLongestReviewWaitsList } from '../vending/vending-longest-review-waits-list.component';
import { VendingProductPopularityList } from '../vending/vending-product-popularity-list.component';
import { VendingTimeToStockoutList } from '../vending/vending-time-to-stockout-list.component';
import { VendingTopConsumersList } from '../vending/vending-top-consumers-list.component';
import { InsightId } from './insight-ids';
import { InsightDefinition, InsightDetailContentProps, editableBinFilters, entityOnlyFilters, lockedBinFilters } from './insight-types';

const StalePudoPickUpsDetail = ({ accountId }: InsightDetailContentProps) => (
    <StalePudoTransactionsList
        insightId={InsightId.PUDO_STALE_PICK_UPS}
        listId='insights-detail-stale-pick-ups-list'
        accountId={accountId}
        infoKind={ChartInfoKind.STALE_PICK_UP_TRANSACTIONS_LIST}
        timerName={TransactionTimerName.TRANSACTION_PICK_UP_PENDING}
        title={
            <FormattedMessage
                id='platform.analytics.insights.stale-pick-ups.title'
                description='Title for the stale pick-ups transaction list on the PuDo analytics insights tab'
                defaultMessage='Stale pick-ups'
            />
        }
    />
);

const StalePudoDropOffsDetail = ({ accountId }: InsightDetailContentProps) => (
    <StalePudoTransactionsList
        insightId={InsightId.PUDO_STALE_DROP_OFFS}
        listId='insights-detail-stale-drop-offs-list'
        accountId={accountId}
        infoKind={ChartInfoKind.STALE_DROP_OFF_TRANSACTIONS_LIST}
        timerName={TransactionTimerName.TRANSACTION_DROP_OFF_PENDING}
        title={
            <FormattedMessage
                id='platform.analytics.insights.stale-drop-offs.title'
                description='Title for the stale drop-offs transaction list on the PuDo analytics insights tab'
                defaultMessage='Stale drop-offs'
            />
        }
    />
);

const StaleNivalizUrnsDropOffsDetail = ({ accountId }: InsightDetailContentProps) => (
    <StalePudoTransactionsList
        insightId={InsightId.NIVALIZ_URNS_STALE_DROP_OFFS}
        listId='insights-detail-nivaliz-urns-stale-drop-offs-list'
        accountId={accountId}
        application={Application.NIVALIZ}
        infoKind={ChartInfoKind.STALE_DROP_OFF_TRANSACTIONS_LIST}
        timerName={TransactionTimerName.TRANSACTION_DROP_OFF_PENDING}
        feature={Feature.OUTBOUND_TRANSACTION}
        title={
            <FormattedMessage
                id='platform.analytics.insights.nivaliz.urns-stale-drop-offs.title'
                description='Title for the urns stale drop-offs transaction list on the Nivaliz analytics insights tab'
                defaultMessage='Urns: Stale drop-offs'
            />
        }
    />
);

const StaleNivalizUrnsPickUpsDetail = ({ accountId }: InsightDetailContentProps) => (
    <StalePudoTransactionsList
        insightId={InsightId.NIVALIZ_URNS_STALE_PICK_UPS}
        listId='insights-detail-nivaliz-urns-stale-pick-ups-list'
        accountId={accountId}
        application={Application.NIVALIZ}
        infoKind={ChartInfoKind.STALE_PICK_UP_TRANSACTIONS_LIST}
        timerName={TransactionTimerName.TRANSACTION_PICK_UP_PENDING}
        feature={Feature.OUTBOUND_TRANSACTION}
        title={
            <FormattedMessage
                id='platform.analytics.insights.nivaliz.urns-stale-pick-ups.title'
                description='Title for the urns stale pick-ups transaction list on the Nivaliz analytics insights tab'
                defaultMessage='Urns: Stale pick-ups'
            />
        }
    />
);

const StaleNivalizCoffinsDropOffsDetail = ({ accountId }: InsightDetailContentProps) => (
    <StalePudoTransactionsList
        insightId={InsightId.NIVALIZ_COFFINS_STALE_DROP_OFFS}
        listId='insights-detail-nivaliz-coffins-stale-drop-offs-list'
        accountId={accountId}
        application={Application.NIVALIZ}
        infoKind={ChartInfoKind.STALE_DROP_OFF_TRANSACTIONS_LIST}
        timerName={TransactionTimerName.TRANSACTION_DROP_OFF_PENDING}
        feature={Feature.INBOUND_TRANSACTION}
        title={
            <FormattedMessage
                id='platform.analytics.insights.nivaliz.coffins-stale-drop-offs.title'
                description='Title for the coffins stale drop-offs transaction list on the Nivaliz analytics insights tab'
                defaultMessage='Coffins: Stale drop-offs'
            />
        }
    />
);

const StaleNivalizCoffinsPickUpsDetail = ({ accountId }: InsightDetailContentProps) => (
    <StalePudoTransactionsList
        insightId={InsightId.NIVALIZ_COFFINS_STALE_PICK_UPS}
        listId='insights-detail-nivaliz-coffins-stale-pick-ups-list'
        accountId={accountId}
        application={Application.NIVALIZ}
        infoKind={ChartInfoKind.STALE_PICK_UP_TRANSACTIONS_LIST}
        timerName={TransactionTimerName.TRANSACTION_PICK_UP_PENDING}
        feature={Feature.INBOUND_TRANSACTION}
        title={
            <FormattedMessage
                id='platform.analytics.insights.nivaliz.coffins-stale-pick-ups.title'
                description='Title for the coffins stale pick-ups transaction list on the Nivaliz analytics insights tab'
                defaultMessage='Coffins: Stale pick-ups'
            />
        }
    />
);

export const INSIGHT_DEFINITIONS: InsightDefinition[] = [
    {
        id: InsightId.PUDO_STALE_PICK_UPS,
        filters: entityOnlyFilters(['spot']),
        tab: 'pudo',
        infoKind: ChartInfoKind.STALE_PICK_UP_TRANSACTIONS_LIST,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.stale-pick-ups.title'
                description='Title for the stale pick-ups transaction list on the PuDo analytics insights tab'
                defaultMessage='Stale pick-ups'
            />
        ),
        DetailContent: StalePudoPickUpsDetail
    },
    {
        id: InsightId.PUDO_STALE_DROP_OFFS,
        filters: entityOnlyFilters(['spot']),
        tab: 'pudo',
        infoKind: ChartInfoKind.STALE_DROP_OFF_TRANSACTIONS_LIST,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.stale-drop-offs.title'
                description='Title for the stale drop-offs transaction list on the PuDo analytics insights tab'
                defaultMessage='Stale drop-offs'
            />
        ),
        DetailContent: StalePudoDropOffsDetail
    },
    {
        id: InsightId.PUDO_SLOWEST_DROP_OFF_USERS,
        reportType: ReportType.PUDO_TRANSACTIONS,
        filters: lockedBinFilters('30d', ChartBinSize.FULL_PERIOD, ['spot']),
        tab: 'pudo',
        chartKey: PudoTransactionTimersDurationByUserDropOffListChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.pudo-transaction-timer-duration-by-user-list.slowest-drop-off-title'
                description='Title for the PuDo slowest-senders list on analytics insights'
                defaultMessage='Slowest senders'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.analytics.insights.pudo-transaction-timer-duration-by-user-list.slowest-drop-off-subtitle'
                description='Subtitle indicating slowest senders covers the last 30 days on the PuDo analytics insights tab'
                defaultMessage='last 30 days'
            />
        ),
        DetailContent: PudoSlowestDropOffUsersList
    },
    {
        id: InsightId.PUDO_SLOWEST_PICK_UP_USERS,
        reportType: ReportType.PUDO_TRANSACTIONS,
        filters: lockedBinFilters('30d', ChartBinSize.FULL_PERIOD, ['spot']),
        tab: 'pudo',
        chartKey: PudoTransactionTimersDurationByUserPickUpListChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.pudo-transaction-timer-duration-by-user-list.slowest-pick-up-title'
                description='Title for the PuDo slowest-receivers list on analytics insights'
                defaultMessage='Slowest receivers'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.analytics.insights.pudo-transaction-timer-duration-by-user-list.slowest-pick-up-subtitle'
                description='Subtitle indicating slowest receivers covers the last 30 days on the PuDo analytics insights tab'
                defaultMessage='last 30 days'
            />
        ),
        DetailContent: PudoSlowestPickUpUsersList
    },
    {
        id: InsightId.PUDO_TRANSACTIONS_PER_SENDER,
        reportType: ReportType.PUDO_TRANSACTIONS,
        filters: lockedBinFilters('30d', ChartBinSize.FULL_PERIOD, ['spot']),
        tab: 'pudo',
        chartKey: PudoTransactionVolumeBySenderListChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.pudo-transaction-volume-by-sender-list.top-senders-title'
                description='Title for the PuDo top-senders list on analytics insights'
                defaultMessage='Top senders'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.analytics.insights.pudo-transaction-volume-by-sender-list.subtitle'
                description='Subtitle indicating transactions per sender covers the last 30 days on the PuDo analytics insights tab'
                defaultMessage='last 30 days'
            />
        ),
        DetailContent: PudoTransactionVolumeBySenderList
    },
    {
        id: InsightId.PUDO_TRANSACTIONS_PER_RECEIVER,
        reportType: ReportType.PUDO_TRANSACTIONS,
        filters: lockedBinFilters('30d', ChartBinSize.FULL_PERIOD, ['spot']),
        tab: 'pudo',
        chartKey: PudoTransactionVolumeByReceiverListChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.pudo-transaction-volume-by-receiver-list.top-receivers-title'
                description='Title for the PuDo top-receivers list on analytics insights'
                defaultMessage='Top receivers'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.analytics.insights.pudo-transaction-volume-by-receiver-list.subtitle'
                description='Subtitle indicating transactions per receiver covers the last 30 days on the PuDo analytics insights tab'
                defaultMessage='last 30 days'
            />
        ),
        DetailContent: PudoTransactionVolumeByReceiverList
    },
    {
        id: InsightId.PUDO_TRANSACTIONS_BY_SPOT,
        reportType: ReportType.PUDO_TRANSACTIONS,
        filters: lockedBinFilters('30d', ChartBinSize.FULL_PERIOD, ['spot']),
        tab: 'pudo',
        chartKey: PudoTransactionVolumeBySpotDonutChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.pudo-transaction-volume-by-spot-donut-chart.title'
                description='Title for the PuDo transactions-by-SPOT donut chart on analytics insights'
                defaultMessage='Transactions by SPOT'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.analytics.insights.pudo-transaction-volume-by-spot-donut-chart.subtitle'
                description='Subtitle indicating transactions by SPOT covers the last 30 days of PuDo transaction volume grouped by SPOT'
                defaultMessage='last 30 days'
            />
        ),
        DetailContent: PudoTransactionsBySpotDonutChart
    },
    {
        id: InsightId.PUDO_DAILY_TURNOVER_RATE,
        filters: editableBinFilters('30d', ChartBinSize.DAY, [ChartBinSize.DAY, ChartBinSize.MONTH, ChartBinSize.FULL_PERIOD], ['spot']),
        tab: 'pudo',
        infoKind: ChartInfoKind.DAILY_TURNOVER_RATE_LINE,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.pudo-daily-turnover-rate-line-chart.title'
                description='Title for the PuDo daily turnover rate line chart on analytics insights'
                defaultMessage='Daily turnover rate'
            />
        ),
        DetailContent: PudoDailyTurnoverRateLineChart
    },
    {
        id: InsightId.PUDO_COMPARTMENT_USAGE_BY_SIZE,
        reportType: ReportType.PUDO_TRANSACTIONS,
        filters: lockedBinFilters('30d', ChartBinSize.FULL_PERIOD, ['spot']),
        tab: 'pudo',
        chartKey: PudoTransactionVolumeBySlotDimensionDonutChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.pudo-compartment-usage-by-size-donut-chart.slot-usage-title'
                description='Title for the PuDo SLOT usage-by-size donut chart on analytics insights'
                defaultMessage='SLOT usage by size'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.analytics.insights.pudo-compartment-usage-by-size-donut-chart.subtitle'
                description='Subtitle indicating compartment usage by size covers the last 30 days of PuDo transaction volume grouped by SLOT dimension'
                defaultMessage='last 30 days'
            />
        ),
        DetailContent: PudoCompartmentUsageBySizeDonutChart
    },
    {
        id: InsightId.PUDO_ACTIVITY_WEEKDAY_HEATMAP,
        filters: lockedBinFilters('6mo', ChartBinSize.DAY, ['spot']),
        tab: 'pudo',
        chartKey: PudoTransactionTimerActivityWeekdayHeatmapChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.last-6-months-pudo-transaction-timer-activity-weekday-heatmap-chart.title'
                description='Title of the PuDo insights heatmap showing combined completed drop-off and pick-up timer volume by weekday over the last six months'
                defaultMessage='Activity heatmap'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.analytics.insights.last-6-months-pudo-transaction-timer-activity-weekday-heatmap-chart.subtitle'
                description='Subtitle on the PuDo activity heatmap indicating the chart covers the last six months'
                defaultMessage='last 6 months'
            />
        ),
        DetailContent: Last6MonthsPudoTransactionTimerActivityWeekdayHeatmapChart
    },
    {
        id: InsightId.PUDO_ACTIVITY_HOUR_DAY_HEATMAP,
        filters: lockedBinFilters('2w', ChartBinSize.HOUR, ['spot']),
        tab: 'pudo',
        chartKey: PudoTransactionTimerActivityHourDayHeatmapChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.last-2-weeks-pudo-transaction-timer-activity-hour-day-heatmap-chart.title'
                description='Title of the PuDo insights heatmap showing combined completed drop-off and pick-up timer volume by hour of day over the last two weeks'
                defaultMessage='Hourly activity heatmap'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.analytics.insights.last-2-weeks-pudo-transaction-timer-activity-hour-day-heatmap-chart.subtitle-14-days'
                description='Subtitle on the PuDo hourly activity heatmap indicating the chart covers the last 14 days'
                defaultMessage='last 14 days'
            />
        ),
        DetailContent: Last2WeeksPudoTransactionTimerActivityHourDayHeatmapChart
    },
    {
        id: InsightId.NIVALIZ_URNS_STALE_DROP_OFFS,
        filters: entityOnlyFilters(['spot']),
        tab: 'nivaliz',
        infoKind: ChartInfoKind.STALE_DROP_OFF_TRANSACTIONS_LIST,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.nivaliz.urns-stale-drop-offs.title'
                description='Title for the urns stale drop-offs transaction list on the Nivaliz analytics insights tab'
                defaultMessage='Urns: Stale drop-offs'
            />
        ),
        DetailContent: StaleNivalizUrnsDropOffsDetail
    },
    {
        id: InsightId.NIVALIZ_URNS_STALE_PICK_UPS,
        filters: entityOnlyFilters(['spot']),
        tab: 'nivaliz',
        infoKind: ChartInfoKind.STALE_PICK_UP_TRANSACTIONS_LIST,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.nivaliz.urns-stale-pick-ups.title'
                description='Title for the urns stale pick-ups transaction list on the Nivaliz analytics insights tab'
                defaultMessage='Urns: Stale pick-ups'
            />
        ),
        DetailContent: StaleNivalizUrnsPickUpsDetail
    },
    {
        id: InsightId.NIVALIZ_COFFINS_STALE_DROP_OFFS,
        filters: entityOnlyFilters(['spot']),
        tab: 'nivaliz',
        infoKind: ChartInfoKind.STALE_DROP_OFF_TRANSACTIONS_LIST,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.nivaliz.coffins-stale-drop-offs.title'
                description='Title for the coffins stale drop-offs transaction list on the Nivaliz analytics insights tab'
                defaultMessage='Coffins: Stale drop-offs'
            />
        ),
        DetailContent: StaleNivalizCoffinsDropOffsDetail
    },
    {
        id: InsightId.NIVALIZ_COFFINS_STALE_PICK_UPS,
        filters: entityOnlyFilters(['spot']),
        tab: 'nivaliz',
        infoKind: ChartInfoKind.STALE_PICK_UP_TRANSACTIONS_LIST,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.nivaliz.coffins-stale-pick-ups.title'
                description='Title for the coffins stale pick-ups transaction list on the Nivaliz analytics insights tab'
                defaultMessage='Coffins: Stale pick-ups'
            />
        ),
        DetailContent: StaleNivalizCoffinsPickUpsDetail
    },
    {
        id: InsightId.NIVALIZ_DAILY_TURNOVER_RATE,
        filters: editableBinFilters('30d', ChartBinSize.DAY, [ChartBinSize.DAY, ChartBinSize.MONTH, ChartBinSize.FULL_PERIOD], ['spot']),
        tab: 'nivaliz',
        infoKind: ChartInfoKind.DAILY_TURNOVER_RATE_LINE,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.nivaliz-daily-turnover-rate-line-chart.title'
                description='Title for the Nivaliz daily turnover rate line chart on analytics insights'
                defaultMessage='Daily turnover rate'
            />
        ),
        DetailContent: NivalizDailyTurnoverRateLineChart
    },
    {
        id: InsightId.NIVALIZ_COMPARTMENT_USAGE_BY_SIZE,
        reportType: ReportType.NIVALIZ_TRANSACTIONS,
        filters: lockedBinFilters('30d', ChartBinSize.FULL_PERIOD, ['spot']),
        tab: 'nivaliz',
        chartKey: NivalizTransactionVolumeBySlotDimensionDonutChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.nivaliz-compartment-usage-by-size-donut-chart.slot-usage-title'
                description='Title for the Nivaliz SLOT usage-by-size donut chart on analytics insights'
                defaultMessage='SLOT usage by size'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.analytics.insights.nivaliz-compartment-usage-by-size-donut-chart.subtitle'
                description='Subtitle indicating compartment usage by size covers the last 30 days of Nivaliz transaction volume grouped by SLOT dimension'
                defaultMessage='last 30 days'
            />
        ),
        DetailContent: NivalizCompartmentUsageBySizeDonutChart
    },
    {
        id: InsightId.NIVALIZ_URNS_ACTIVITY_WEEKDAY_HEATMAP,
        filters: lockedBinFilters('6mo', ChartBinSize.DAY, ['spot']),
        tab: 'nivaliz',
        chartKey: NivalizOutboundTransactionTimerActivityWeekdayHeatmapChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.last-6-months-nivaliz-urns-transaction-timer-activity-weekday-heatmap-chart.title'
                description='Title of the Nivaliz urns insights heatmap showing combined completed drop-off and pick-up timer volume by weekday over the last six months'
                defaultMessage='Urns: Activity heatmap'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.analytics.insights.last-6-months-nivaliz-transaction-timer-activity-weekday-heatmap-chart.subtitle'
                description='Subtitle on the Nivaliz activity heatmap indicating the chart covers the last six months'
                defaultMessage='last 6 months'
            />
        ),
        DetailContent: Last6MonthsNivalizUrnsTransactionTimerActivityWeekdayHeatmapChart
    },
    {
        id: InsightId.NIVALIZ_COFFINS_ACTIVITY_WEEKDAY_HEATMAP,
        filters: lockedBinFilters('6mo', ChartBinSize.DAY, ['spot']),
        tab: 'nivaliz',
        chartKey: NivalizInboundTransactionTimerActivityWeekdayHeatmapChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.last-6-months-nivaliz-coffins-transaction-timer-activity-weekday-heatmap-chart.title'
                description='Title of the Nivaliz coffins insights heatmap showing combined completed drop-off and pick-up timer volume by weekday over the last six months'
                defaultMessage='Coffins: Activity heatmap'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.analytics.insights.last-6-months-nivaliz-transaction-timer-activity-weekday-heatmap-chart.subtitle'
                description='Subtitle on the Nivaliz activity heatmap indicating the chart covers the last six months'
                defaultMessage='last 6 months'
            />
        ),
        DetailContent: Last6MonthsNivalizCoffinsTransactionTimerActivityWeekdayHeatmapChart
    },
    {
        id: InsightId.NIVALIZ_URNS_ACTIVITY_HOUR_DAY_HEATMAP,
        filters: lockedBinFilters('2w', ChartBinSize.HOUR, ['spot']),
        tab: 'nivaliz',
        chartKey: NivalizOutboundTransactionTimerActivityHourDayHeatmapChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.last-2-weeks-nivaliz-urns-transaction-timer-activity-hour-day-heatmap-chart.title'
                description='Title of the Nivaliz urns insights heatmap showing combined completed drop-off and pick-up timer volume by hour of day over the last 14 days'
                defaultMessage='Urns: Hourly activity heatmap'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.analytics.insights.last-2-weeks-nivaliz-transaction-timer-activity-hour-day-heatmap-chart.subtitle-14-days'
                description='Subtitle on the Nivaliz hourly activity heatmap indicating the chart covers the last 14 days'
                defaultMessage='last 14 days'
            />
        ),
        DetailContent: Last2WeeksNivalizUrnsTransactionTimerActivityHourDayHeatmapChart
    },
    {
        id: InsightId.NIVALIZ_COFFINS_ACTIVITY_HOUR_DAY_HEATMAP,
        filters: lockedBinFilters('2w', ChartBinSize.HOUR, ['spot']),
        tab: 'nivaliz',
        chartKey: NivalizInboundTransactionTimerActivityHourDayHeatmapChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.last-2-weeks-nivaliz-coffins-transaction-timer-activity-hour-day-heatmap-chart.title'
                description='Title of the Nivaliz coffins insights heatmap showing combined completed drop-off and pick-up timer volume by hour of day over the last 14 days'
                defaultMessage='Coffins: Hourly activity heatmap'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.analytics.insights.last-2-weeks-nivaliz-transaction-timer-activity-hour-day-heatmap-chart.subtitle-14-days'
                description='Subtitle on the Nivaliz hourly activity heatmap indicating the chart covers the last 14 days'
                defaultMessage='last 14 days'
            />
        ),
        DetailContent: Last2WeeksNivalizCoffinsTransactionTimerActivityHourDayHeatmapChart
    },
    {
        id: InsightId.VENDING_PRODUCT_POPULARITY,
        filters: lockedBinFilters('60d', ChartBinSize.MONTH, ['spot', 'product']),
        tab: 'vending',
        infoKind: ChartInfoKind.VENDING_PRODUCT_POPULARITY_LIST,
        title: (
            <FormattedMessage
                id='platform.statistics.vending.last-60-days-vending-package-volume-by-product-monthly-list-chart.title'
                description='Title of the vending dashboard list showing products with the largest month-over-month consumption increase and decrease'
                defaultMessage='Product popularity'
            />
        ),
        DetailContent: VendingProductPopularityList
    },
    {
        id: InsightId.VENDING_TIME_TO_STOCKOUT,
        filters: lockedBinFilters('30d', ChartBinSize.FULL_PERIOD, ['spot', 'product']),
        tab: 'vending',
        infoKind: ChartInfoKind.VENDING_TIME_TO_STOCKOUT_LIST,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.vending-time-to-stockout-list.title'
                description='Title for the vending list showing expected days until products run out of stock on analytics insights'
                defaultMessage='Expected out of stock in days'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.analytics.insights.vending-time-to-stockout-list.subtitle'
                description='Subtitle indicating time-to-stockout uses the last 30 days of consumption run-rate'
                defaultMessage='last 30 days run-rate'
            />
        ),
        DetailContent: VendingTimeToStockoutList
    },
    {
        id: InsightId.VENDING_TOP_CONSUMERS,
        filters: lockedBinFilters('30d', ChartBinSize.FULL_PERIOD, ['spot', 'user']),
        tab: 'vending',
        chartKey: VendingPackageVolumeByUserListChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.statistics.vending.last-30-days-vending-package-volume-by-user-list-chart.title'
                description='Title of the vending dashboard list showing the users with the highest consumption volume over the last 30 days'
                defaultMessage='Top consumers'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='widget.last-30-days'
                defaultMessage='last 30 days'
            />
        ),
        DetailContent: VendingTopConsumersList
    },
    {
        id: InsightId.VENDING_LONGEST_REVIEW_WAITS,
        filters: lockedBinFilters('30d', ChartBinSize.FULL_PERIOD, ['spot', 'product']),
        tab: 'vending',
        chartKey: VendingPackageTimersDurationAuditPendingByProductListChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.vending-longest-review-waits-list.title'
                description='Title for the vending list of products with the longest open audit-pending wait on analytics insights'
                defaultMessage='Longest waiting for review'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='widget.last-30-days'
                defaultMessage='last 30 days'
            />
        ),
        DetailContent: VendingLongestReviewWaitsList
    },
    {
        id: InsightId.VENDING_PEAK_CONSUMPTION_WINDOWS,
        filters: lockedBinFilters('2w', ChartBinSize.HOUR, ['spot', 'product']),
        tab: 'vending',
        chartKey: VendingPackageVolumeHourDayHeatmapChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.vending-package-volume-hour-of-day-bar-chart.title'
                description='Title for the vending hour-of-day consumption peaks chart on analytics insights'
                defaultMessage='Peak consumption windows'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.analytics.insights.last-2-weeks-vending-package-volume-hour-day-heatmap-chart.subtitle'
                description='Subtitle on the vending hourly activity heatmap indicating the chart covers the last 14 days'
                defaultMessage='last 14 days'
            />
        ),
        DetailContent: Last2WeeksVendingPackageVolumeHourDayHeatmapChart
    },
    {
        id: InsightId.VENDING_REPLENISHMENT_ACTIVITY_HOUR_DAY_HEATMAP,
        filters: lockedBinFilters('2w', ChartBinSize.HOUR, ['spot']),
        tab: 'vending',
        chartKey: VendingReplenishmentTransactionVolumeHourDayHeatmapChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.last-2-weeks-vending-replenishment-activity-hour-day-heatmap-chart.title'
                description='Title of the vending insights heatmap showing completed inbound replenishment transaction volume by hour of day over the last two weeks'
                defaultMessage='Replenishment heatmap'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.analytics.insights.last-2-weeks-vending-replenishment-activity-hour-day-heatmap-chart.subtitle'
                description='Subtitle on the vending replenishment heatmap indicating the chart covers the last 14 days'
                defaultMessage='last 14 days'
            />
        ),
        DetailContent: Last2WeeksVendingReplenishmentActivityHourDayHeatmapChart
    },
    {
        id: InsightId.VENDING_RECYCLE_SLOTS_FILL_RATE,
        filters: lockedBinFilters('30d', ChartBinSize.DAY, ['spot']),
        tab: 'vending',
        chartKey: VendingRecycleSpotFillRateLineChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.vending-recycle-slots-fill-rate-metric-chart.title'
                description='Title for the vending recycle SLOT occupancy percentage metric on analytics insights'
                defaultMessage='Recycle slots fill rate'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.analytics.insights.last-30-days-vending-recycle-spot-fill-rate-line-chart.subtitle'
                description='Subtitle on the vending recycle fill rate line chart indicating the chart covers the last 30 days'
                defaultMessage='last 30 days'
            />
        ),
        DetailContent: Last30DaysVendingRecycleSpotFillRateLineChart
    },
    {
        id: InsightId.LENDING_USAGE_COUNT_LAST_MONTH,
        filters: lockedBinFilters('30d', ChartBinSize.FULL_PERIOD, ['spot', 'product']),
        tab: 'lending',
        chartKey: LendingEquipmentUsesVolumeByProductListChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.lending-equipment-uses-volume-by-product-list.title'
                description='Title for the lending insights list showing product use counts over the last 30 days'
                defaultMessage='Usage count in last month'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='widget.last-30-days'
                defaultMessage='last 30 days'
            />
        ),
        DetailContent: LendingEquipmentUsesVolumeByProductList
    },
    {
        id: InsightId.LENDING_EQUIPMENT_POPULARITY,
        filters: lockedBinFilters('60d', ChartBinSize.MONTH, ['spot', 'product']),
        tab: 'lending',
        chartKey: LendingOutboundPackageVolumeByProductMonthlyListChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.statistics.lending.last-60-days-lending-outbound-package-volume-by-product-monthly-list-chart.title'
                description='Title of the lending dashboard list showing equipments with the largest month-over-month lend increase and decrease'
                defaultMessage='Equipment popularity'
            />
        ),
        DetailContent: Last60DaysLendingOutboundPackageVolumeByProductMonthlyListChart
    },
    {
        id: InsightId.LENDING_AVERAGE_DURATION,
        filters: lockedBinFilters('30d', ChartBinSize.FULL_PERIOD, ['product']),
        tab: 'lending',
        chartKey: EquipmentTimersDurationByProductListChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.statistics.lending.last-30-days-lending-average-use-duration-by-product-list-card.title'
                description='Title of the lending dashboard list showing equipments with the highest and lowest average completed lend duration over the last 30 days'
                defaultMessage='Average duration in use'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='widget.last-30-days'
                defaultMessage='last 30 days'
            />
        ),
        DetailContent: Last30DaysLendingAverageUseDurationByProductListCard
    },
    {
        id: InsightId.LENDING_ASSET_USAGE_HOURS,
        filters: lockedBinFilters('30d', ChartBinSize.FULL_PERIOD, ['product']),
        tab: 'lending',
        infoKind: ChartInfoKind.EQUIPMENT_DURATION_BY_EQUIPMENT_LIST,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.lending-equipment-usage-hours-list.title'
                description='Title for the lending per-asset usage hours list on analytics insights'
                defaultMessage='Asset usage hours'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.analytics.insights.lending-equipment-usage-hours-list.subtitle'
                description='Subtitle indicating asset usage hours covers the last 30 days for individual equipment'
                defaultMessage='last 30 days · by equipment'
            />
        ),
        DetailContent: LendingEquipmentUsageHoursList
    },
    {
        id: InsightId.LENDING_PEAK_CHECKOUT_WINDOWS,
        filters: lockedBinFilters('2w', ChartBinSize.HOUR, ['spot', 'product']),
        tab: 'lending',
        chartKey: LendingOutboundPackageVolumeHourDayHeatmapChartRenderer.definition.key,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.lending-outbound-package-volume-hour-of-day-bar-chart.title'
                description='Title for the lending checkout hour-of-day peaks chart on analytics insights'
                defaultMessage='Peak checkout windows'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.analytics.insights.lending-outbound-package-volume-hour-day-heatmap-chart.subtitle'
                description='Subtitle on the lending checkout heatmap indicating the chart covers the last 14 days'
                defaultMessage='last 14 days'
            />
        ),
        DetailContent: LendingOutboundPackageVolumeHourDayHeatmapChart
    },
    {
        id: InsightId.LENDING_PEAK_RETURN_WINDOWS,
        filters: lockedBinFilters('2w', ChartBinSize.HOUR, ['spot', 'product']),
        tab: 'lending',
        chartKey: LendingReturnPackageVolumeHourDayHeatmapChartRenderer.definition.key,
        title: (
            <FormattedMessage
                id='platform.analytics.insights.lending-return-package-volume-hour-of-day-bar-chart.title'
                description='Title for the lending return hour-of-day peaks chart on analytics insights'
                defaultMessage='Peak return windows'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.analytics.insights.lending-return-package-volume-hour-day-heatmap-chart.subtitle'
                description='Subtitle on the lending return heatmap indicating the chart covers the last 14 days'
                defaultMessage='last 14 days'
            />
        ),
        DetailContent: LendingReturnPackageVolumeHourDayHeatmapChart
    },
    {
        id: InsightId.LENDING_OUTGOING_HEATMAP,
        filters: lockedBinFilters('6mo', ChartBinSize.DAY, ['spot', 'product']),
        tab: 'lending',
        chartKey: LendingOutboundPackageVolumeWeekdayHeatmapChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.statistics.lending.last-6-months-lending-outbound-package-volume-weekday-heatmap-chart.title'
                description='Title of the lending heatmap showing pick-up package volume by weekday over the last six months'
                defaultMessage='Pick-up heatmap'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.statistics.lending.last-6-months-lending-outbound-package-volume-weekday-heatmap-chart.subtitle'
                description='Subtitle on the lending pick-up heatmap indicating the chart covers the last six months'
                defaultMessage='last 6 months'
            />
        ),
        DetailContent: Last6MonthsLendingOutboundPackageVolumeWeekdayHeatmapChart
    },
    {
        id: InsightId.LENDING_INCOMING_HEATMAP,
        filters: lockedBinFilters('6mo', ChartBinSize.DAY, ['spot', 'product']),
        tab: 'lending',
        chartKey: LendingReturnPackageVolumeWeekdayHeatmapChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.statistics.lending.last-6-months-lending-return-package-volume-weekday-heatmap-chart.title'
                description='Title of the lending heatmap showing drop-off return package volume by weekday over the last six months'
                defaultMessage='Drop-off heatmap'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.statistics.lending.last-6-months-lending-return-package-volume-weekday-heatmap-chart.subtitle'
                description='Subtitle on the lending drop-off heatmap indicating the chart covers the last six months'
                defaultMessage='last 6 months'
            />
        ),
        DetailContent: Last6MonthsLendingReturnPackageVolumeWeekdayHeatmapChart
    },
    {
        id: InsightId.HARDWARE_UPTIME_OVER_TIME,
        filters: editableBinFilters('30d', ChartBinSize.DAY, [ChartBinSize.HOUR, ChartBinSize.DAY, ChartBinSize.MONTH], ['spot', 'iotType', 'iotBrand']),
        tab: 'hardware',
        chartKey: IotsUptimeLineChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.statistics.hardware.last-30-days-hardware-iots-uptime-line-chart.title'
                description='Title of the hardware insights chart showing IoT uptime over the last 30 days'
                defaultMessage='Uptime over time'
            />
        ),
        DetailContent: Last30DaysHardwareIotsUptimeLineChart
    },
    {
        id: InsightId.HARDWARE_STATUS_MIX_OVER_TIME,
        filters: editableBinFilters('30d', ChartBinSize.DAY, [ChartBinSize.DAY, ChartBinSize.MONTH], ['spot', 'iotType', 'iotBrand']),
        tab: 'hardware',
        chartKey: IotsVolumeByStatusBarChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.statistics.hardware.last-30-days-hardware-iots-volume-by-status-bar-chart.title'
                description='Title of the hardware insights stacked bar chart showing IoT status mix over the last 30 days'
                defaultMessage='Status mix over time'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.statistics.hardware.last-30-days-hardware-iots-volume-by-status-bar-chart.subtitle'
                description='Subtitle for the hardware status mix chart indicating the last 30 days window'
                defaultMessage='Last 30 days'
            />
        ),
        DetailContent: Last30DaysHardwareIotsVolumeByStatusBarChart
    },
    {
        id: InsightId.HARDWARE_UPTIME_BY_TYPE,
        filters: lockedBinFilters('30d', ChartBinSize.FULL_PERIOD, ['spot', 'iotBrand']),
        tab: 'hardware',
        chartKey: IotsUptimeByTypeListChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.statistics.hardware.last-30-days-hardware-iots-uptime-by-type-list-chart.title'
                description='Title of the hardware insights list showing average uptime percentage by IoT device type'
                defaultMessage='Uptime by type'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.statistics.hardware.last-30-days-hardware-iots-uptime-by-type-list-chart.subtitle'
                description='Subtitle for the hardware uptime-by-type list indicating the last 30 days window'
                defaultMessage='Last 30 days'
            />
        ),
        DetailContent: Last30DaysHardwareIotsUptimeByTypeListChart
    },
    {
        id: InsightId.HARDWARE_FLEET_BY_TYPE,
        filters: entityOnlyFilters(['spot', 'iotBrand']),
        tab: 'hardware',
        chartKey: IotsVolumeByTypeListChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.statistics.hardware.hardware-iots-volume-by-type-list-chart.title'
                description='Title of the hardware dashboard list showing IoT counts grouped by device type'
                defaultMessage='Fleet by type'
            />
        ),
        DetailContent: HardwareIotsVolumeByTypeListChart
    },
    {
        id: InsightId.HARDWARE_UPTIME_WEEKDAY_PATTERN,
        filters: lockedBinFilters('6mo', ChartBinSize.DAY, ['spot', 'iotType', 'iotBrand']),
        tab: 'hardware',
        chartKey: IotsUptimeWeekdayHeatmapChart.definition.key,
        title: (
            <FormattedMessage
                id='platform.statistics.hardware.last-6-months-hardware-iots-uptime-weekday-heatmap-chart.title'
                description='Title of the hardware insights heatmap showing IoT uptime by weekday over the last six months'
                defaultMessage='Uptime weekday pattern'
            />
        ),
        subtitle: (
            <FormattedMessage
                id='platform.statistics.hardware.last-6-months-hardware-iots-uptime-weekday-heatmap-chart.subtitle'
                description='Subtitle on the hardware uptime weekday heatmap indicating the chart covers the last six months'
                defaultMessage='Last 6 months'
            />
        ),
        DetailContent: Last6MonthsHardwareIotsUptimeWeekdayHeatmapChart
    }
];

const INSIGHT_BY_ID = new Map(INSIGHT_DEFINITIONS.map((definition) => [definition.id, definition]));

export const getInsightDefinition = (insightId: string | undefined): InsightDefinition | undefined => (insightId ? INSIGHT_BY_ID.get(insightId) : undefined);
